export const inventoryColumns = [
  {
    field: "zoneID",
    headerName: "Zone ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "locationID",
    headerName: "Location ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    sortable: false,
    align: "left",
    flex: 2,
    minWidth: 200,
  },
  {
    field: "palletNbr",
    headerName: "Pallet Nbr",
    sortable: false,
    align: "left",
    flex: 1.2,
    minWidth: 112,
  },{
    field: "cartonID",
    headerName: "Carton ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "quantity",
    headerName: "Total Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "quantityOnHold",
    headerName: "Quantity On Hold",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "quantityAvailable",
    headerName: "Quantity Available",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "holdQuantity",
    headerName: "Hold Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    editable: true,
    type: 'number',
    headerClassName: 'custom-editable-header right-align-header',
  },
  {
    field: "finalQuantity",
    headerName: "Final Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerClassName: 'right-align-header',
  },
  
  {
    field: "baseUOM",
    headerName: "Base UOM",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "mln",
    headerName: "MLN",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 130,
  },
  {
    field: "vendorCode",
    headerName: "Vendor Code",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "packType",
    headerName: "Pack Type",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "oln",
    headerName: "OLN",
    sortable: false,
    align: "left",
    flex: 1.2,
    minWidth: 112,
  },
];

export const openStockHoldColumns = [
  {
    field: "zoneID",
    headerName: "Zone ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "locationID",
    headerName: "Location ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    sortable: false,
    align: "left",
    flex: 2,
    minWidth: 200,
  },
  {
    field: "palletNbr",
    headerName: "Pallet Nbr",
    sortable: false,
    align: "left",
    flex: 1.2,
    minWidth: 112,
  },
  {
    field: "holdQuantity",
    headerName: "Hold Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "remainHoldQuantity",
    headerName: "Quantity Still On Hold",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "unholdQuantity",
    headerName: "Unhold Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    editable: true,
    type: 'number',
    headerClassName: 'custom-editable-header right-align-header',
  },
  {
    field: "mln",
    headerName: "MLN",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 130,
  },
];